import { ROUTES_CONFIG } from '@/config/routes.config';
import { useTRPC } from '@/trpc';
import { useQuery } from '@tanstack/react-query';
import React from 'react'
import { useTypedParams } from 'react-router-typesafe-routes';

const PlayerData = () => {
    const { trpc } = useTRPC();
    const { player_id } = useTypedParams(ROUTES_CONFIG.APP.PLAYER_DETAIL);

    const { data:player } = useQuery({
        queryKey: ['players', player_id],
        queryFn: async () => {
            const player = await trpc.players.getById.query({ player_id: player_id });
            return player;
        },
    })

  return (
    <div className='flex flex-col gap-1 bg-foreground/10 rounded-md border p-3'>
        {player?.nameInCountry &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Naam in thuisland</p>
            <p className='text-sm'>{player?.nameInCountry}</p>
        </div>
        }
        {player?.dateOfBirth &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Geboortedatum</p>
            <p className='text-sm'>{player?.dateOfBirth}</p>
        </div>
        }
        {player?.placeOfBirthCity && 
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Geboorteplaats</p>
            <p className='text-sm'>{player?.placeOfBirthCity}</p>
        </div>
        }
        {player?.height && 
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Hoogte</p>
            <p className='text-sm'>{player?.height}</p>
        </div>
        }
        {(player?.citizenship && player?.citizenship?.length > 0) && 
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Burgerschap</p>
            <p className='text-sm'>{player?.citizenship?.join(", ")}</p>
        </div>
        }
        {(player?.positionOther && player?.positionOther?.length > 0) &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Positie</p>
            <p className='text-sm'>{player?.positionOther?.join(", ")}</p>
        </div>
        }
        {player?.foot &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Voet</p>
            <p className='text-sm'>{player?.foot}</p>
        </div>
        }
        {player?.joinedOn &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Aangesloten op</p>
            <p className='text-sm'>{player?.joinedOn}</p>
        </div>
        }
        {player?.contractExpires &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Contract vervalt</p>
            <p className='text-sm'>{player?.contractExpires}</p>
        </div>
        }
        {player?.contractOption &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Contract optie</p>
            <p className='text-sm'>{player?.contractOption}</p>
        </div>
        }
        {player?.lastContractExtension &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Laatste contractverlenging</p>
            <p className='text-sm'>{player?.lastContractExtension}</p>
        </div>
        }
        {player?.outfitter &&
        <div className='flex items-center justify-between gap-4'>
            <p className='text-sm text-foreground/50'>Outfitter</p>
            <p className='text-sm'>{player?.outfitter}</p>
        </div>
        }
    </div>
  )
}

export default PlayerData